import {
  Document,
  Image,
  Link,
  Page,
  Path,
  Rect,
  Svg,
  Text,
  View,
  pdf,
} from "@react-pdf/renderer";
import {
  EnumPoljaEvidencije,
  IAddress,
  ILocalStorage,
  IRecordPointClass,
} from "../../../../redux/interfaces";
import { ITextFields, styles } from "./Tables";
import {
  TableEDUMainHeader,
  TableRowEduEvdListaDefinisanihTacaka,
  TableRowEduEvdListaDefinisanihTacakaHeader,
} from "./Pdf/EduPdf/EduPdfListaDefinisanihTacaka";
import {
  TableFooterPdf,
  TableRichDescriptionPdf,
} from "./Pdf/SveEvidencije/SveEvidencije";
import {
  TableRowCIPOEvdListaDefinisanihTacaka,
  TableRowCIPOEvdListaDefinisanihTacakaHeader,
} from "./Pdf/CIPOPdf/CIPOPdfListaDefinisanihTacaka";
import {
  TableRowCIPPEvdListaDefinisanihTacaka,
  TableRowCIPPEvdListaDefinisanihTacakaHeader,
} from "./Pdf/CIPPPdf/CIPPPdfListaDefinisanihTacaka";
import {
  TableRowDeratizacijaEvdListaDefinisanihTacaka,
  TableRowDeratizacijaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DeratizacijaPdf/DeratizacijaPdfListaDefinisanihTacaka";
import {
  TableRowDeratizacijaKontrolaEvdListaDefinisanihTacaka,
  TableRowDeratizacijaKontrolaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DeratizacijaKontrolaPdf/DeratizacijaKontrolaPdfListaDefinisanihTacaka";
import {
  TableRowDeratizacijaKorekcijaEvdListaDefinisanihTacaka,
  TableRowDeratizacijaKorekcijaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DeratizacijaKorekcijaPdf/DeratizacijaKorekcijaPdfListaDefinisanihTacaka";
import {
  TableRowDezSrEvdListaDefinisanihTacaka,
  TableRowDezSrEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DezSrPdf/DezSrPdfListaDefinisanihTacaka";
import {
  TableRowDezinfekcijaEvdListaDefinisanihTacaka,
  TableRowDezinfekcijaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DezinfekcijaPdf/DezinfekcijaPdfListaDefinisanihTacaka";
import {
  TableRowDezinsekcijaEvdListaDefinisanihTacaka,
  TableRowDezinsekcijaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DezinsekcijaPdf/DezinsekcijaPdfListaDefinisanihTacaka";
import {
  TableRowDezinsekcijaKontrolaEvdListaDefinisanihTacaka,
  TableRowDezinsekcijaKontrolaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DezinsekcijaKontrolaPdf/DezinsekcijaKontrolaPdfListaDefinisanihTacaka";
import {
  TableRowDezinsekcijaKorekcijaEvdListaDefinisanihTacaka,
  TableRowDezinsekcijaKorekcijaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DezinsekcijaKorekcijaPdf/DezinsekcijaKorekcijaPdfListaDefinisanihTacaka";
import {
  TableRowDobavljaciEvdListaDefinisanihTacaka,
  TableRowDobavljaciEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DobavljaciPdf/DobavljaciPdfListaDefinisanihTacaka";
import {
  TableRowDostavaEvdListaDefinisanihTacaka,
  TableRowDostavaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/DostavaPdf/DostavaPdfListaDefinisanihTacaka";
import {
  TableRowMolEvdListaDefinisanihTacaka,
  TableRowMolEvdListaDefinisanihTacakaHeader,
} from "./Pdf/MolerskiRadoviPdf/MolerskiRadoviPdfListaDefinisanihTacaka";
import {
  TableRowOpremaEvdListaDefinisanihTacaka,
  TableRowOpremaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/OpremaPdf/OpremaPdfListaDefinisanihTacaka";
import {
  TableRowOtpadEvdListaDefinisanihTacaka,
  TableRowOtpadEvdListaDefinisanihTacakaHeader,
} from "./Pdf/OtpadPdf/OtpadPdfListaDefinisanihTacaka";
import {
  TableRowPrijemEvdListaDefinisanihTacaka,
  TableRowPrijemEvdListaDefinisanihTacakaHeader,
} from "./Pdf/PrijemPdf/PrijemPdfListaDefinisanihTacaka";
import {
  TableRowSanitarniEvdListaDefinisanihTacaka,
  TableRowSanitarniEvdListaDefinisanihTacakaHeader,
} from "./Pdf/SanitarniPdf/SanitarniPdfListaDefinisanihTacaka";
import {
  TableRowTemperaturaEvdListaDefinisanihTacaka,
  TableRowTemperaturaEvdListaDefinisanihTacakaHeader,
} from "./Pdf/TemperaturaPdf/TemperaturaPdfListaDefinisanihTacaka";
import {
  TableRowTemperaturaKKTProizvodiEvdListaDefinisanihTacaka,
  TableRowTemperaturaKKTProizvodiEvdListaDefinisanihTacakaHeader,
} from "./Pdf/TemperaturaKKTProizvodiPdf/TemperaturaKKTProizvodiPdfListaDefinisanihTacaka";
import {
  TableRowTemperaturaOgranicenaEvdListaDefinisanihTacaka,
  TableRowTemperaturaOgranicenaEvdListaDefinisanihTacakaHeader,
  TableTemperaturaOgranicenaListaDefinisanihTacakaHeader,
} from "./Pdf/TemperaturaOgranicenaPdf/TemperaturaOgranicenaPdfListaDefinisanihTacaka";
import {
  TableRowTemperaturaOgranicenaKKTEvdListaDefinisanihTacaka,
  TableRowTemperaturaOgranicenaKKTEvdListaDefinisanihTacakaHeader,
  TableTemperaturaOgranicenaKKTListaDefinisanihTacakaHeader,
} from "./Pdf/TemperaturaOgranicenaKKTPdf/TemperaturaOgranicenaKKTPdfListaDefinisanihTacaka";
import { formatDate, getMonthBoundaries } from "../helpers/FormatDate";
import {
  getAddress,
  getAdekvatnoPrikupljen,
  getBrojRacuna,
  getCilj,
  getDatumObuke,
  getDokument,
  getEarliestCreatedAt,
  getExtraDate,
  getExtraVrijeme,
  getExtraVrijemeKorekcije,
  getIdTax,
  getImeIPrezime,
  getKolicina,
  getNapomena,
  getNaziv,
  getOpis,
  getOpisKontrole,
  getOpisKorekcije,
  getPdvTax,
  getPhoneNumber,
  getPosiljalac,
  getPotpis,
  getPrimalac,
  getPrimjedba,
  getPrimjena,
  getProdutType,
  getProizvod,
  getRadnoMjesto,
  getRichDescription,
  getSlikaDeklaracije,
  getStanjeKontrole,
  getStanjeKorekcije,
  getTema,
  getTemperatura,
  getTipEvidencije,
  getUposlenik,
  getUpustvoZaUpotrebu,
  getVaziDo,
  getVaziOd,
  getVrsta,
  getdatumKorekcije,
  getdozvoljenaTempMax,
  getdozvoljenaTempMaxKorekcije,
  getdozvoljenaTempMin,
  getdozvoljenaTempMinKorekcije,
  getdozvoljenoOdstupanje,
  getimePrezimeKorekcije,
  getizvrsilacObuke,
  getjedinicaMjere,
  getkorektivnaMjera,
  getmjestoObuke,
  getocitanaTemperatura,
  getocitanaTemperaturaKorekcije,
  getopisMjeereKorekcije,
  getpotpisIzvrsiocaKorekcije,
  getpotpisPosiljalac,
  getpotpisPrimalac,
  getverifikacijaEdukatoraPotpis,
  getverifikacijaEfikasnosti,
  getverifikacijaPrisustvaPotpis,
  safePdfImageSrc,
} from "../helpers/GetRecordPointClass";

import PageNumber from "./PageNumber";
import React from "react";
import logo from "../../../../assets/images/logo-light.png";

const CheckboxIcon = ({ checked }: { checked: boolean }) => (
  <Svg width={12} height={12} viewBox="0 0 24 24">
    <Rect
      x={3}
      y={3}
      width={18}
      height={18}
      rx={2}
      ry={2}
      stroke="#1f2a44"
      strokeWidth={2}
      fill="none"
    />
    {checked && (
      <Path d="M7 12l3 3 7-7" stroke="#1f2a44" strokeWidth={2} fill="none" />
    )}
  </Svg>
);

export interface IPDFBranch {
  name: string;
  address: IAddress;
}

interface PdfDocumentProps {
  data: IRecordPointClass[];
  branch: IPDFBranch;
  evidencija: string;
  res: ITextFields;
  tackaPrimjene: string;
  recordField: EnumPoljaEvidencije;
  startDate: Date;
  endDate: Date;
  richDescription: string;
}
export const extractEvdData = (evdArray: any[], evdProperty?: string) => {
  return evdArray.map((evd, index) => ({
    createdAt: formatDate(evd.createdAt?.toString() || ""),
    id: index,
    evdProperty: evdProperty, // Store the evidence property name
    // Add other properties from the Evd object as needed
  }));
};

export type Record = {
  address: string;
  adekvatnoPrikupljen: boolean;
  cilj: string;
  datum: string;
  datumKorekcije: string | undefined;
  datumObuke: string;
  dokument?: string;
  dozvoljenaTempMax: number | null;
  dozvoljenaTempMaxKorekcije: number | null;
  dozvoljenaTempMin: number | null;
  dozvoljenaTempMinKorekcije: number | null;
  dozvoljenoOdstupanje: number | null;
  extraDatum: string | undefined;
  extraVrijeme: string | undefined;
  fullname: string;
  idTax: string;
  imePrezimeKorekcije: string;
  izvrsilacObuke: string;
  jedinicaMjere: string;
  kolicina: string;
  korektivnaMjera: string;
  mjestoObuke: string;
  napomena: string;
  naziv: string;
  nazivItem: string;
  ocitanaTemperatura: number | null;
  ocitanaTemperaturaKorekcije: number | null;
  opis: string;
  opisKontrole: string;
  opisKorekcije: string;
  opisMjeereKorekcije: string;
  pdvTax: string;
  phoneNumber: string;
  posiljalac: string;
  potpis: string;
  potpisIzvrsiocaKorekcije: string;
  potpisPosiljalac: string;
  potpisPrimalac: string;
  primalac: string;
  primjedba: string;
  temperatura: string;
  primjena: string;
  productType: string;
  radnoMjesto: string;
  slikaDeklaracije?: string;
  stanjeKontrole: boolean;
  stanjeKorekcije: string;
  tema: string;
  tipEvidencije: string;
  uposlenik: string;
  upustvoZaUpotrebu: string;
  vaziDo: string;
  vaziOd: string;
  verifikacijaEdukatoraPotpis: string;
  verifikacijaEfikasnosti: string;
  verifikacijaPrisustvaPotpis: string;
  vrijemeKorekcije: string | undefined;
  vrsta: string;
};

export type GroupedData = {
  [key: string]: Record[];
};

export const getAllEvdData = (point: IRecordPointClass) => {
  const evdProperties = Object.keys(point).filter((key) =>
    /Evd$|Kontrola$|Korekcija$|Proizvodi$/.test(key),
  );
  return evdProperties.flatMap((evdProperty) => {
    const evdArray = point[evdProperty as keyof IRecordPointClass];
    if (Array.isArray(evdArray)) {
      return extractEvdData(evdArray, evdProperty);
    }
    return [];
  });
};
// Lista Definisanih Tacaka
const PdfDocument: React.FC<PdfDocumentProps> = ({
  data,
  branch,
  evidencija,
  res,
  recordField,
  startDate,
  endDate,
  richDescription,
}) => {
  const convertedArray = data.flatMap((item) => {
    const evdData = getAllEvdData(item);
    return evdData.map((evd) => {
      const extraDatum = getExtraDate(item, evd.id, evd.evdProperty);

      return {
        naziv: item.RecordTraceConfig?.title
          ? item.RecordTraceConfig?.title
          : "",
        datum: formatDate(getEarliestCreatedAt(item, evd.id)?.toString() || ""),
        fullname: getImeIPrezime(item, evd.id),
        potpis: safePdfImageSrc(getPotpis(item, evd.id)),
        brojRacuna: getBrojRacuna(item, evd.id),
        tipEvidencije: getTipEvidencije(item, evd.id),
        slikaDeklaracije: safePdfImageSrc(
          getSlikaDeklaracije(item, evd.id) ?? "",
        ),
        opisKorekcije: getOpisKorekcije(item, evd.id),
        opisKontrole: getOpisKontrole(item, evd.id),
        stanjeKontrole: getStanjeKontrole(item, evd.id),
        stanjeKorekcije: getStanjeKorekcije(item, evd.id),
        nazivItem: getNaziv(item, evd.id),
        primjena: getPrimjena(item, evd.id),
        upustvoZaUpotrebu: getUpustvoZaUpotrebu(item, evd.id),
        vrsta: getVrsta(item, evd.id),
        productType: getProdutType(item, evd.id),
        address: getAddress(item, evd.id),
        idTax: getIdTax(item, evd.id),
        pdvTax: getPdvTax(item, evd.id),
        phoneNumber: getPhoneNumber(item, evd.id),
        extraDatum: extraDatum,
        extraVrijeme: getExtraVrijeme(item, evd.id, evd.evdProperty),
        posiljalac: getPosiljalac(item, evd.id),
        potpisPosiljalac: safePdfImageSrc(getpotpisPosiljalac(item, evd.id)),
        primalac: getPrimalac(item, evd.id),
        potpisPrimalac: safePdfImageSrc(getpotpisPrimalac(item, evd.id)),
        dokument: getDokument(item, evd.id),
        primjedba: getPrimjedba(item, evd.id),
        korektivnaMjera: getkorektivnaMjera(item, evd.id),
        temperatura: getTemperatura(item, evd.id),
        datumObuke: formatDate(getDatumObuke(item, evd.id)?.toString() || ""),
        cilj: getCilj(item, evd.id),
        izvrsilacObuke: getizvrsilacObuke(item, evd.id),
        mjestoObuke: getmjestoObuke(item, evd.id),
        radnoMjesto: getRadnoMjesto(item, evd.id),
        tema: getTema(item, evd.id),
        verifikacijaEdukatoraPotpis: safePdfImageSrc(
          getverifikacijaEdukatoraPotpis(item, evd.id),
        ),
        verifikacijaEfikasnosti: getverifikacijaEfikasnosti(item, evd.id),
        verifikacijaPrisustvaPotpis: safePdfImageSrc(
          getverifikacijaPrisustvaPotpis(item, evd.id),
        ),
        opis: getOpis(item, evd.id),
        uposlenik: getUposlenik(item, evd.id),
        vaziOd: formatDate(getVaziOd(item, evd.id)?.toString() || ""),
        vaziDo: formatDate(getVaziDo(item, evd.id)?.toString() || ""),
        jedinicaMjere: getjedinicaMjere(item, evd.id),
        kolicina: getKolicina(item, evd.id),
        datumKorekcije: getdatumKorekcije(item, evd.id),
        dozvoljenaTempMax: getdozvoljenaTempMax(item, evd.id),
        dozvoljenaTempMaxKorekcije: getdozvoljenaTempMaxKorekcije(item, evd.id),
        dozvoljenaTempMin: getdozvoljenaTempMin(item, evd.id),
        dozvoljenaTempMinKorekcije: getdozvoljenaTempMinKorekcije(item, evd.id),
        dozvoljenoOdstupanje: getdozvoljenoOdstupanje(item, evd.id),
        imePrezimeKorekcije: getimePrezimeKorekcije(item, evd.id),
        ocitanaTemperatura: getocitanaTemperatura(item, evd.id),
        ocitanaTemperaturaKorekcije: getocitanaTemperaturaKorekcije(
          item,
          evd.id,
        ),
        opisMjeereKorekcije: getopisMjeereKorekcije(item, evd.id),
        potpisIzvrsiocaKorekcije: safePdfImageSrc(
          getpotpisIzvrsiocaKorekcije(item, evd.id),
        ),
        vrijemeKorekcije: getExtraVrijemeKorekcije(item, evd.id),
        napomena: getNapomena(item, evd.id),
        adekvatnoPrikupljen: getAdekvatnoPrikupljen(item, evd.id),
        proizvod: getProizvod(item, evd.id),
        checklistjson: (item as any)?.CheckListEvd?.[evd.id]?.checklistjson,
      };
    });
  });

  // Helper function to parse dates from extraDatum (format: "DD.MM.YYYY HH:mm" or "DD.MM.YYYY")
  const parseDateFromExtraDatum = (dateStr: string): Date => {
    if (!dateStr || dateStr.trim() === "") {
      return new Date(0);
    }
    const parts = dateStr.split(" ");
    const datePart = parts[0];
    const timePart = parts[1] || "00:00";
    const [day, month, year] = datePart.split(".");
    if (!day || !month || !year) {
      return new Date(0);
    }
    const [hours, minutes] = timePart.split(":");
    const date = new Date(
      parseInt(year),
      parseInt(month) - 1,
      parseInt(day),
      parseInt(hours) || 0,
      parseInt(minutes) || 0,
    );
    return isNaN(date.getTime()) ? new Date(0) : date;
  };

  // Sort ALL evidence by date and time (newest first) for PDF display
  // Use extraDatum if available (contains formatted date with time), otherwise fallback to datum
  // Also consider extraVrijeme if available for more precise sorting
  convertedArray.sort((a, b) => {
    // Helper to get full date-time for sorting
    const getSortDate = (item: any): Date => {
      // Try extraDatum first (contains formatted date with time)
      if (item.extraDatum) {
        return parseDateFromExtraDatum(item.extraDatum);
      }

      // If extraDatum is not available but we have datum and extraVrijeme, combine them
      if (item.datum && item.extraVrijeme) {
        try {
          const datumDate = parseCustomDate(item.datum);
          const vrijemeParts = item.extraVrijeme.split(":");
          if (vrijemeParts.length >= 2) {
            datumDate.setHours(
              parseInt(vrijemeParts[0]) || 0,
              parseInt(vrijemeParts[1]) || 0,
              0,
              0,
            );
          }
          return datumDate;
        } catch (e) {
          // Fallback to datum only
        }
      }

      // Fallback to datum only
      if (item.datum) {
        return parseCustomDate(item.datum);
      }

      return new Date(0);
    };

    const dateA = getSortDate(a);
    const dateB = getSortDate(b);

    // Sort descending (newest first)
    return dateB.getTime() - dateA.getTime();
  });

  function groupByTema(records: Record[]): GroupedData {
    return records.reduce((result, record) => {
      const { tema } = record;
      if (!result[tema]) {
        result[tema] = [];
      }
      result[tema].push(record);
      return result;
    }, {} as GroupedData);
  }

  const groupedData = groupByTema(convertedArray);

  function parseCustomDate(dateStr: string): Date {
    if (!dateStr || dateStr.trim() === "") {
      return new Date(0); // Return epoch date for empty strings
    }

    const parts = dateStr.split(".");
    if (parts.length < 3) {
      return new Date(0); // Return epoch date if format is invalid
    }

    const [day, month, yearAndTime] = parts;
    if (!yearAndTime) {
      return new Date(0); // Return epoch date if yearAndTime is missing
    }

    const timeParts = yearAndTime.split(" ");
    if (timeParts.length < 2) {
      return new Date(0); // Return epoch date if time is missing
    }

    const [year, time] = timeParts;
    if (!year || !time) {
      return new Date(0); // Return epoch date if year or time is missing
    }

    return new Date(`${year}-${month}-${day}T${time}:00`);
  }

  // Note: Sort by date (newest first) is already done above
  // No need for secondary sort - the date sort above handles everything

  const storedUser = localStorage.getItem("user");
  let person: ILocalStorage | null = null;
  if (storedUser) {
    person = JSON.parse(storedUser);
  }

  let PDFOrientation: "landscape" | "portrait" = "portrait";
  if (
    recordField === EnumPoljaEvidencije.OpremaEvd_V1 ||
    recordField === EnumPoljaEvidencije.OtpadEvd_V1 ||
    recordField === EnumPoljaEvidencije.MolEvd_V1 ||
    recordField === EnumPoljaEvidencije.DezSrEvd_V1 ||
    recordField === EnumPoljaEvidencije.DostavaEvd_V1 ||
    recordField === EnumPoljaEvidencije.EduZapEvd_V1 ||
    recordField === EnumPoljaEvidencije.DobavljacEvd_V1 ||
    recordField === EnumPoljaEvidencije.PrijemRobeEvd_V1 ||
    recordField === EnumPoljaEvidencije.Dezinsekcija_Korekcija_V1 ||
    recordField === EnumPoljaEvidencije.Deratizacija_Korekcije_V1 ||
    recordField === EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1 ||
    recordField === EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1 ||
    recordField === EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1
  ) {
    PDFOrientation = "landscape";
  }

  // Special layout: Checklist -> one record per page with user, signature, document link, and detailed checklist
  if (recordField === EnumPoljaEvidencije.CheckListEvd_V1) {
    return (
      <Document>
        {convertedArray.map((item, index) => (
          <Page
            key={index}
            size="A4"
            orientation={"portrait"}
            style={styles.page}
          >
            <View style={styles.centeredView}>
              <View style={styles.logoContainer}>
                <Image
                  style={[styles.title, styles.logoImageSmall]}
                  src={logo}
                />
              </View>
              <Text style={styles.title}>{evidencija}</Text>
              <Text style={styles.subtitle}>
                {data[0].RecordTraceConfig?.title &&
                  data[0].RecordTraceConfig?.title.toString()}
                {data[0].RecordTraceConfig?.revizija &&
                  " - " + data[0].RecordTraceConfig?.revizija}
              </Text>
              <Text style={styles.lastSubtitle}>{data[0].name}</Text>
            </View>

            <View style={styles.header}>
              <Text>{branch.name}</Text>
              <Text>{branch.address.street}</Text>
              <Text>{branch.address.zipCode + " " + branch.address.city}</Text>
              <Text>{branch.address.country}</Text>
            </View>

            <View style={styles.topRightCorner}>
              <Text>{res.odabraniPeriod}</Text>
              <Text style={{ marginTop: 5 }}>
                {getMonthBoundaries(startDate, endDate)}
              </Text>
            </View>

            {/* Overview info (without tacka primjene row) */}
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.datum}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  <Text>{item.datum}</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.imeIPrezime}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  <Text>{item.fullname}</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.potpis}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  {item.potpis ? (
                    <Image
                      style={[styles.tableCell, styles.signatureImage]}
                      src={item.potpis}
                    />
                  ) : (
                    <Text>-</Text>
                  )}
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.dokument}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  {item.dokument && (
                    <Link
                      src={item.dokument}
                      style={{ ...styles.tableCell, ...styles.link }}
                    >
                      {res.dokument}
                    </Link>
                  )}
                </View>
              </View>
            </View>

            {/* Checklist items: two columns table with icons, normal font */}
            <View style={styles.table}>
              {(() => {
                const items: any[] = (item as any)?.checklistjson || [];
                if (!items.length) {
                  return (
                    <View style={styles.tableRow}>
                      <View style={styles.tableColHorizontal}>
                        <Text style={styles.tableCell}>-</Text>
                      </View>
                      <View style={styles.tableColHorizontal}>
                        <Text style={styles.tableCell}>-</Text>
                      </View>
                    </View>
                  );
                }
                const rows: any[][] = [];
                for (let i = 0; i < items.length; i += 2) {
                  rows.push([items[i], items[i + 1]]);
                }
                return (
                  <>
                    {rows.map((pair, rIdx) => (
                      <View key={rIdx} style={styles.tableRow} wrap={false}>
                        <View style={styles.tableColHorizontal}>
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CheckboxIcon checked={!!pair[0]?.value} />
                            <Text style={[styles.tableCell, { marginLeft: 6 }]}>
                              {pair[0]?.name || "-"}
                            </Text>
                          </View>
                        </View>
                        <View style={styles.tableColHorizontal}>
                          {pair[1] ? (
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <CheckboxIcon checked={!!pair[1]?.value} />
                              <Text
                                style={[styles.tableCell, { marginLeft: 6 }]}
                              >
                                {pair[1]?.name || "-"}
                              </Text>
                            </View>
                          ) : (
                            <Text style={styles.tableCell}></Text>
                          )}
                        </View>
                      </View>
                    ))}
                  </>
                );
              })()}
            </View>
            <PageNumber />
          </Page>
        ))}
        <Page size="A4" orientation={PDFOrientation} style={styles.page}>
          <TableRichDescriptionPdf richDescription={richDescription} />
          <PageNumber />
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      <Page size="A4" orientation={PDFOrientation} style={styles.page}>
        <View style={styles.centeredView}>
          <View style={styles.logoContainer}>
            <Image style={[styles.title, styles.logoImage]} src={logo} />
          </View>
          <Text style={styles.title}>{evidencija}</Text>
          <Text style={styles.subtitle}>
            {data[0].RecordTraceConfig?.title &&
              data[0].RecordTraceConfig?.title.toString()}
            {data[0].RecordTraceConfig?.revizija &&
              " - " + data[0].RecordTraceConfig?.revizija}
          </Text>
          <Text style={styles.lastSubtitle}>{data[0].name}</Text>
        </View>

        {/* Header Section */}
        <View style={styles.header}>
          <Text>{branch.name}</Text>
          <Text>{branch.address.street}</Text>
          <Text>{branch.address.zipCode + " " + branch.address.city}</Text>
          <Text>{branch.address.country}</Text>
        </View>
        {/* TODO: Implement for Selected Month - now only current print  */}
        <View style={styles.topRightCorner}>
          <Text>{res.odabraniPeriod}</Text>
          <Text style={{ marginTop: 5 }}>
            {getMonthBoundaries(startDate, endDate)}
          </Text>
        </View>
        {/* Dobavljaci Evd */}
        {recordField === EnumPoljaEvidencije.DobavljacEvd_V1 && (
          <View style={styles.table}>
            <TableRowDobavljaciEvdListaDefinisanihTacakaHeader
              naziv={res.naziv}
              productType={res.productType}
              address={res.address}
              idTax={res.idTax}
              pdvTax={res.pdvTax}
              phoneNumber={res.phoneNumber}
            />
            {convertedArray.map((item, index) => (
              <TableRowDobavljaciEvdListaDefinisanihTacaka
                key={index}
                naziv={item.nazivItem}
                productType={item.productType}
                address={item.address}
                idTax={item.idTax}
                pdvTax={item.pdvTax}
                phoneNumber={item.phoneNumber}
              />
            ))}
          </View>
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1 && (
          <TableTemperaturaOgranicenaKKTListaDefinisanihTacakaHeader
            title1={res.dozvoljenaTempMax}
            title2={res.dozvoljenaTempMin}
            title3={res.dozvoljenoOdstupanje}
            value1={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMax}
            value2={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMin}
            value3={data[0].RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje}
          />
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaOgranicenaKKTEvdListaDefinisanihTacakaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              resnapomena={res.napomena}
              respotpis={res.potpis}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
              reskorektivnaMjera={res.korektivnaMjera}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaOgranicenaKKTEvdListaDefinisanihTacaka
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
                napomena={item.napomena}
                korektivnaMjera={item.adekvatnoPrikupljen}
              />
            ))}
          </View>
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1 && (
          <TableTemperaturaOgranicenaKKTListaDefinisanihTacakaHeader
            title1={res.dozvoljenaTempMax}
            title2={res.dozvoljenaTempMin}
            title3={res.dozvoljenoOdstupanje}
            value1={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMax}
            value2={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMin}
            value3={data[0].RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje}
          />
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaKKTProizvodiEvdListaDefinisanihTacakaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              resnapomena={res.napomena}
              respotpis={res.potpis}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
              reskorektivnaMjera={res.korektivnaMjera}
              resproizvod={res.proizvod}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaKKTProizvodiEvdListaDefinisanihTacaka
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
                napomena={item.napomena}
                korektivnaMjera={item.adekvatnoPrikupljen}
                proizvod={item.proizvod}
              />
            ))}
          </View>
        )}

        {/* Dezinfekcija */}
        {recordField === EnumPoljaEvidencije.Dezinfekcija_V1 && (
          <View style={styles.table}>
            <TableRowDezinfekcijaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              slikaDeklaracije={res.slikaDeklaracije}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinfekcijaEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                slikaDeklaracije={item.slikaDeklaracije}
                slikaRes={res.dokument}
              />
            ))}
          </View>
        )}
        {/* Deratizacija Kontrola */}
        {recordField === EnumPoljaEvidencije.Deratizacija_Kontrole_V1 && (
          <View style={styles.table}>
            <TableRowDeratizacijaKontrolaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              opisKontrole={res.opisKontrole}
              stanjeKontrole={res.stanjeKontrole}
            />
            {convertedArray.map((item, index) => (
              <TableRowDeratizacijaKontrolaEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                opisKontrole={item.opisKontrole}
                stanjeKontrole={item.stanjeKontrole ? res.da : res.ne}
              />
            ))}
          </View>
        )}
        {/* Dezinsekcija Kontrola */}
        {recordField === EnumPoljaEvidencije.Dezinsekcija_Kontrola_V1 && (
          <View style={styles.table}>
            <TableRowDezinsekcijaKontrolaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              opisKontrole={res.opisKontrole}
              stanjeKontrole={res.stanjeKontrole}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinsekcijaKontrolaEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                opisKontrole={item.opisKontrole}
                stanjeKontrole={item.stanjeKontrole ? res.da : res.ne}
              />
            ))}
          </View>
        )}
        {/* Dezinsekcija Korekcija */}
        {recordField === EnumPoljaEvidencije.Dezinsekcija_Korekcija_V1 && (
          <View style={styles.table}>
            <TableRowDezinsekcijaKorekcijaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              stanjeKorekcije={res.stanjeKorekcije}
              opisKorekcije={res.opisKorekcije}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinsekcijaKorekcijaEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                stanjeKorekcije={item.stanjeKorekcije}
                opisKorekcije={item.opisKorekcije}
              />
            ))}
          </View>
        )}
        {/* Deratizacija Korekcija */}
        {recordField === EnumPoljaEvidencije.Deratizacija_Korekcije_V1 && (
          <View style={styles.table}>
            <TableRowDeratizacijaKorekcijaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              stanjeKorekcije={res.stanjeKorekcije}
              opisKorekcije={res.opisKorekcije}
            />
            {convertedArray.map((item, index) => (
              <TableRowDeratizacijaKorekcijaEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                stanjeKorekcije={item.stanjeKorekcije}
                opisKorekcije={item.opisKorekcije}
              />
            ))}
          </View>
        )}
        {/* Dezinsekcija */}
        {recordField === EnumPoljaEvidencije.Dezinsekcija_V1 && (
          <View style={styles.table}>
            <TableRowDezinsekcijaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              slikaDeklaracije={res.slikaDeklaracije}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinsekcijaEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                slikaDeklaracije={item.slikaDeklaracije}
                slikaRes={res.dokument}
              />
            ))}
          </View>
        )}
        {/* Deratizacija */}
        {recordField === EnumPoljaEvidencije.Deratizacija_V1 && (
          <View style={styles.table}>
            <TableRowDeratizacijaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              slikaDeklaracije={res.slikaDeklaracije}
            />
            {convertedArray.map((item, index) => (
              <TableRowDeratizacijaEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                slikaDeklaracije={item.slikaDeklaracije}
                slikaRes={res.dokument}
              />
            ))}
          </View>
        )}
        {/* Edu Evd */}
        {recordField === EnumPoljaEvidencije.EduZapEvd_V1 &&
          Object.entries(groupedData).map(([tema, records], index) => (
            <View key={index} style={styles.tableHidden}>
              <TableEDUMainHeader
                key={index}
                datumObuke={records[0].datumObuke}
                cilj={records[0].cilj}
                izvrsilacObuke={records[0].izvrsilacObuke}
                mjestoObuke={records[0].mjestoObuke}
                tema={records[0].tema}
                tip={records[0].tipEvidencije}
                datumObukeres={res.datumObuke}
                ciljres={res.cilj}
                izvrsilacObukeres={res.izvrsilacObuke}
                mjestoObukeres={res.mjestoObuke}
                temares={res.tema}
                tipres={res.tip}
              />

              <View key={index} style={styles.table}>
                <TableRowEduEvdListaDefinisanihTacakaHeader
                  radnoMjesto={res.radnoMjesto}
                  verifikacijaEdukatoraPotpis={res.verifikacijaEdukatoraPotpis}
                  verifikacijaEfikasnosti={res.verifikacijaEfikasnosti}
                  verifikacijaPrisustvaPotpis={res.verifikacijaPrisustvaPotpis}
                  dokument={res.dokument}
                  imePrezime={res.imePrezime}
                />
                {records.map((item, index) => (
                  <TableRowEduEvdListaDefinisanihTacaka
                    key={index}
                    imePrezime={item.fullname}
                    dokument={item.dokument}
                    radnoMjesto={item.radnoMjesto}
                    verifikacijaEdukatoraPotpis={
                      item.verifikacijaEdukatoraPotpis
                    }
                    verifikacijaEfikasnosti={item.verifikacijaEfikasnosti}
                    verifikacijaPrisustvaPotpis={
                      item.verifikacijaPrisustvaPotpis
                    }
                    slikaRes={res.dokument}
                  />
                ))}
              </View>
            </View>
          ))}

        {/* Prijem Robe */}
        {recordField === EnumPoljaEvidencije.PrijemRobeEvd_V1 && (
          <View style={styles.table}>
            <TableRowPrijemEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              potpisano={res.potpis}
              dokument={res.dokument}
              korektivnaMjera={res.korektivnaMjera}
              temperatura={res.temperatura}
              posiljalac={res.posiljalac}
              potpisPosiljalac={res.potpisPosiljalac}
              primalac={res.primalac}
              primjedba={res.primjedba}
            />
            {convertedArray.map((item, index) => (
              <TableRowPrijemEvdListaDefinisanihTacaka
                key={index}
                datum={item.extraDatum || item.datum || ""}
                potpisano={item.potpis}
                dokument={item.dokument}
                korektivnaMjera={item.korektivnaMjera}
                temperatura={item.temperatura}
                posiljalac={item.posiljalac}
                potpisPosiljalac={item.potpisPosiljalac}
                primalac={item.primalac}
                primjedba={item.primjedba}
                slikaRes={res.dokument}
              />
            ))}
          </View>
        )}

        {/* Oprema Evd */}
        {recordField === EnumPoljaEvidencije.OpremaEvd_V1 && (
          <View style={styles.table}>
            <TableRowOpremaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              imePrezime={res.imePrezime}
              izvrsioc={res.izvrsioc}
              opis={res.opis}
              potpis={res.potpis}
              potpisIzvrsioca={res.potpisIzvrsioca}
              tip={res.tip}
            />
            {convertedArray.map((item, index) => (
              <TableRowOpremaEvdListaDefinisanihTacaka
                key={index}
                datum={item.extraDatum}
                potpis={item.potpis}
                fullname={item.fullname}
                izvrsioc={item.izvrsilacObuke}
                opis={item.opis}
                potpisIzvrsioca={item.potpisPosiljalac}
                tip={item.tipEvidencije}
              />
            ))}
          </View>
        )}
        {/* Sanitarni Evd  */}
        {recordField === EnumPoljaEvidencije.SanEvd_V1 && (
          <View style={styles.table}>
            <TableRowSanitarniEvdListaDefinisanihTacakaHeader
              dokument={res.dokument}
              uposlenik={res.uposlenik}
              vaziOd={res.vaziOd}
              vaziDo={res.vaziDo}
            />
            {convertedArray.map((item, index) => (
              <TableRowSanitarniEvdListaDefinisanihTacaka
                key={index}
                dokument={item.dokument}
                uposlenik={item.uposlenik}
                vaziOd={item.vaziOd}
                vaziDo={item.vaziDo}
                slikaRes={res.dokument}
              />
            ))}
          </View>
        )}
        {/* Dostava Evd  */}
        {recordField === EnumPoljaEvidencije.DostavaEvd_V1 && (
          <View style={styles.table}>
            <TableRowDostavaEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              dokument={res.dokument}
              korektivnaMjera={res.korektivnaMjera}
              posiljalac={res.posiljalac}
              potpisPrimalac={res.potpisPrimalac}
              primalac={res.primalac}
              primjedba={res.primjedba}
              ispravnaPosiljka={res.ispravnaPosiljka}
              brojRacuna={res.brojRacuna}
            />
            {convertedArray.map((item, index) => (
              <TableRowDostavaEvdListaDefinisanihTacaka
                key={index}
                datum={item.extraDatum ? item.extraDatum : ""}
                dokument={item.dokument}
                korektivnaMjera={item.korektivnaMjera}
                posiljalac={item.posiljalac}
                potpisPrimalac={item.potpisPrimalac}
                primalac={item.primalac}
                primjedba={item.primjedba}
                slikaRes={res.dokument}
                ispravnaPosiljka={item.stanjeKontrole ? res.da : res.ne}
                brojRacuna={item.brojRacuna}
              />
            ))}
          </View>
        )}
        {/* Dez Sr Evd */}
        {recordField === EnumPoljaEvidencije.DezSrEvd_V1 && (
          <View style={styles.table}>
            <TableRowDezSrEvdListaDefinisanihTacakaHeader
              naziv={res.naziv}
              primjena={res.primjena}
              slika={res.slika}
              upustvoZaUpotrebu={res.upustvoZaUpotrebu}
              vrsta={res.vrsta}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezSrEvdListaDefinisanihTacaka
                key={index}
                naziv={item.nazivItem}
                slika={item.slikaDeklaracije}
                primjena={item.primjena}
                upustvoZaUpotrebu={item.upustvoZaUpotrebu}
                vrsta={item.vrsta}
                slikares={res.dokument}
              />
            ))}
          </View>
        )}
        {/* OTPAD EVD */}
        {recordField === EnumPoljaEvidencije.OtpadEvd_V1 && (
          <View style={styles.table}>
            <TableRowOtpadEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              kolicina={res.kolicina}
              korektivnaMjera={res.otpadKorektivnaMjera}
              potpisPrimaoca={res.potpisPrimalac}
              primaoc={res.primaoc}
              vrstaOtpada={res.vrstaOtpada}
              napomena={res.napomena}
            />
            {convertedArray.map((item, index) => (
              <TableRowOtpadEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                potpis={item.potpis}
                fullname={item.fullname}
                jedinicaMjere={item.jedinicaMjere}
                kolicina={item.kolicina}
                korektivnaMjera={item.adekvatnoPrikupljen ? res.da : res.ne}
                potpisPrimaoca={item.potpisPrimalac}
                primaoc={item.primalac}
                vrstaOtpada={item.vrsta}
                napomena={item.korektivnaMjera}
              />
            ))}
          </View>
        )}
        {/* Temperatura Evd */}
        {recordField === EnumPoljaEvidencije.TemperaturaEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaEvdListaDefinisanihTacakaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              respotpis={res.potpis}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaEvdListaDefinisanihTacaka
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
              />
            ))}
          </View>
        )}
        {/* Temperatura Ogranicena Evd */}
        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1 && (
          <TableTemperaturaOgranicenaListaDefinisanihTacakaHeader
            title1={res.dozvoljenaTempMax}
            title2={res.dozvoljenaTempMin}
            title3={res.dozvoljenoOdstupanje}
            value1={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMax}
            value2={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMin}
            value3={data[0].RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje}
          />
        )}
        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaOgranicenaEvdListaDefinisanihTacakaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              resnapomena={res.napomena}
              respotpis={res.potpis}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaOgranicenaEvdListaDefinisanihTacaka
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
                napomena={item.napomena}
              />
            ))}
          </View>
        )}
        {/* Mol Evd */}
        {recordField === EnumPoljaEvidencije.MolEvd_V1 && (
          <View style={styles.table}>
            <TableRowMolEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              imePrezime={res.kontrolisaoPrimioRadove}
              izvrsioc={res.izvrsioc}
              opis={res.opis}
              potpisIzvrsioca={res.potpisIzvrsioca}
              potpisano={res.potpis}
            />
            {convertedArray.map((item, index) => (
              <TableRowMolEvdListaDefinisanihTacaka
                key={index}
                imePrezime={item.fullname}
                datum={item.datum}
                izvrsioc={item.izvrsilacObuke}
                opis={item.opis}
                potpisano={item.potpis}
                potpisIzvrsioca={item.potpisPosiljalac}
              />
            ))}
          </View>
        )}
        {/* CIPP EVD */}
        {recordField === EnumPoljaEvidencije.CIPP_V1 && (
          <View style={styles.table}>
            <TableRowCIPPEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.izvrsioc}
              potpis={res.potpis}
            />
            {convertedArray.map((item, index) => (
              <TableRowCIPPEvdListaDefinisanihTacaka
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
              />
            ))}
          </View>
        )}
        {/* CIPO EVD */}
        {recordField === EnumPoljaEvidencije.CIPO_V1 && (
          <View style={styles.table}>
            <TableRowCIPOEvdListaDefinisanihTacakaHeader
              datum={res.datum}
              fullname={res.izvrsioc}
              type={res.napomena}
              potpis={res.potpis}
            />
            {convertedArray.map((item, index) => (
              <TableRowCIPOEvdListaDefinisanihTacaka
                key={index}
                datum={item.extraDatum || item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                type={item.tipEvidencije}
              />
            ))}
          </View>
        )}

        {/* CheckList EVD handled in a dedicated per-page renderer above */}
        <TableFooterPdf
          resPotpis={res.potpisFooter}
          resKontrolisao={res.upisaoFooter}
          kontrolisao={person?.user.fullName}
          potpis={safePdfImageSrc(person?.user.potpis ?? "")}
        />
        <PageNumber />
      </Page>
      <Page size="A4" orientation={PDFOrientation} style={styles.page}>
        <TableRichDescriptionPdf richDescription={richDescription} />
        <PageNumber />
      </Page>
    </Document>
  );
};

/**
 * Wide viewports: open PDF in a new browser tab (needs a sync blank window
 * before async generation so popup blockers do not force a download).
 * Narrow viewports: keep programmatic download for mobile Safari and similar.
 */
export function preferListaEvidencijaPdfInlineTab(): boolean {
  if (typeof window === "undefined") {
    return true;
  }
  return window.matchMedia("(min-width: 768px)").matches;
}

/** Ensures the blob URL is treated as a PDF for inline viewer (not attachment). */
export function createListaEvidencijaPdfBlobUrl(blob: Blob): string {
  const pdfBlob =
    blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  return URL.createObjectURL(pdfBlob);
}

/**
 * Desktop / wide viewports: open the generated PDF in a single new browser tab.
 *
 * Opens the tab only AFTER the blob is ready, so the user never sees a blank
 * placeholder tab. NO `noopener` (it would make `window.open` always return
 * `null`, which is indistinguishable from a real popup-block).
 *
 * Strategy (one tab total):
 *   1. `window.open(url, "_blank")`.
 *   2. Only if it actually returned `null` (popup blocked), fall back to a
 *      single `<a target="_blank">` click. Never `<a download>`.
 */
export function openListaEvidencijaPdfBlobInNewTab(blob: Blob): void {
  const url = createListaEvidencijaPdfBlobUrl(blob);
  const scheduleRevoke = () => {
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  };

  const w = window.open(url, "_blank");
  if (w !== null) {
    scheduleRevoke();
    return;
  }

  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    try {
      document.body.removeChild(a);
    } catch {
      // ignore
    }
  }, 0);
  scheduleRevoke();
}

function triggerPdfBlobDownload(url: string, filename: string): void {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    try {
      document.body.removeChild(link);
    } catch {
      // ignore
    }
    URL.revokeObjectURL(url);
  }, 2000);
}

export const generatePDF = async (
  data: IRecordPointClass[],
  branch: IPDFBranch,
  res: ITextFields,
  tackaPrimjene: string,
  recordField: EnumPoljaEvidencije,
  startDate: Date,
  endDate: Date,
) => {
  try {
    if (!data || data.length === 0) {
      console.error("No data provided for PDF generation");
      return;
    }

    const description = await getRichDescription(data[0]);
    const blob = await pdf(
      <PdfDocument
        recordField={recordField}
        data={data}
        branch={branch}
        evidencija={res.evidencija}
        res={res}
        tackaPrimjene={tackaPrimjene}
        startDate={startDate}
        endDate={endDate}
        richDescription={description}
      />,
    ).toBlob();

    if (!preferListaEvidencijaPdfInlineTab()) {
      triggerPdfBlobDownload(
        createListaEvidencijaPdfBlobUrl(blob),
        "evidence.pdf",
      );
      return;
    }

    openListaEvidencijaPdfBlobInNewTab(blob);
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert(
      `Error generating PDF: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
    throw error;
  }
};
